export const PRODUCT_GROUPS = {
  DAF: 114,
  TRAILERS: 117,
  SCANIA: 123,
  VOLVO: 122,
  CARS: 129,
  COMMERCIAL: 130,
};
